document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
    anchor.addEventListener('click', function (e) {
        e.preventDefault();

        const headerHeight = document.querySelector('header').offsetHeight || 60;
        const target = document.querySelector(this.getAttribute('href'));

        if (target) {
            const position = target.getBoundingClientRect().top + window.pageYOffset - (headerHeight + 30);
            window.scrollTo({ top: position, behavior: 'smooth' });
        }
    });
});